import React, { useEffect, useState } from 'react';
import { Card, CardHeader, ListGroup, CardBody } from 'reactstrap';

import FileListItem from './FileListItem';
import SchoolService from 'services/school';
import Link from "../Link";
import { useSelector } from "react-redux";

const FileList = ({ lessonID, lessonAccess, lessonNoAccess, playVideo, title, teacherPage, shouldDelete, isExamination, showPdf, showFormLink, onlyShowAssignmentId }) => {
  const roles = useSelector((state) => state.auth.roles)
  const [assignments, setAssignments] = useState(null);
  const lessonAccessHighlighter = lessonAccess ? 'box-shadow-pink' : ''
  const examHighlighter = isExamination ? 'la-examination' : ''

  useEffect(() => {
    const getAssignments = async () => {
      try {
        const res = await SchoolService.getAssignmentsByLesson(lessonID);
        setAssignments(res.records);
      } catch (e) { }
    };
    getAssignments(lessonID);
  }, [lessonID]);

  const fileListItems = assignments
    ? assignments.map((el, index) => (
      <FileListItem
        playVideo={() => playVideo(el.id, lessonAccess)}
        type={el.type__c}
        title={el.name}
        fileTitle={el.filnamn__c}
        id={el.id}
        key={el.id}
        lessonID={lessonID}
        description={el.description__c}
        teacherPage={teacherPage}
        shouldDelete={shouldDelete}
        showPdf={() => showPdf(el.id, el.filnamn__c, lessonAccess)}
        showFormLink={() => showFormLink(el.id, el.name, el.formlink_url__c, lessonAccess)}
        formlink={el.formlink_url__c}
        isExamination={isExamination}
        onlyShowAssignmentId={onlyShowAssignmentId}
        lessonNoAccess={lessonNoAccess}
        lessonAccess={lessonAccess}
      />
    ))
    : null;

  return (
    <Card className={`main-card mb-3 la-overflow-visible ${lessonAccessHighlighter} ${examHighlighter}`}>
      <CardHeader>
        <div className="widget-content">
          <div className="widget-content-wrapper">
            {title}
            <div className="center-elem">
              {!roles.includes('student') &&
                (roles.includes('admin') || roles.includes('user') || roles.includes('customer'))
                && <Link id={lessonID} linkType={'lesson'} />}
            </div>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        <ListGroup flush>{fileListItems}</ListGroup>
      </CardBody>
    </Card>
  );
};

export default FileList;
